import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u980419295/domains/tarot.mpmagic.co.uk/public_html/.builds/source/repository/src/app/components/WeeklyCalendarClient.tsx");
